import type { FC } from "react";

import { useFormats } from "@ryde/shared";

import { formatTimeRange } from "./availability-cell.helpers";
import type { IExpandedAvailability } from "./availability-cell.models";

interface IProps {
  item: IExpandedAvailability;
  dayGroupLabel: string;
  dayTypeLabel: string;
}

export const AvailabilityTooltipEntry: FC<IProps> = ({
  item,
  dayGroupLabel,
  dayTypeLabel,
}) => {
  const { timeFormat } = useFormats();
  const timeRange = formatTimeRange({
    from: item.from,
    to: item.to,
    timeFormat,
  });
  const hasDayGroups = item.dayGroupNamesList.length > 0;
  const hasDayTypes = item.dayTypeNamesList.length > 0;

  return (
    <div className="tooltip-entry">
      {timeRange && <div className="tooltip-time">{timeRange}</div>}
      {hasDayGroups && (
        <div className="tooltip-section">
          <span className="tooltip-section-label">{dayGroupLabel}: </span>
          {item.dayGroupNamesList.join(", ")}
        </div>
      )}
      {hasDayTypes && (
        <div className="tooltip-section">
          <span className="tooltip-section-label">{dayTypeLabel}: </span>
          {item.dayTypeNamesList.join(", ")}
        </div>
      )}
    </div>
  );
};
